/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SaleActivityStatus {
    PENDING = 'Pending',
    DONE = 'Done',
    CANCELLED = 'Cancelled',
}
